module.exports = __webpack_public_path__ + "static/media/indexBanner.9fbf1f78.png";